export default [
  [`Размер`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `40-42`, `42-44`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`, `54-56`],
  [`Ширина изделия, см`, `47`, `49`, `52`, `57`, `59`, `61`, `64`, `65`],
  [`Ширина плеч, см`, `39`, `40`, `42`, `45`, `46`, `47`, `49`, `51`],
  [`Длина изделия, см`, `58`, `58`, `61`, `61`, `65`, `69`, `73`, `75`],
  [`Длина рукава, см`, `58`, `58`, `60`, `62`, `65`, `65`, `69`, `69`],
];
